module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYAgMAAACdGdVrAAAACVBMVEUAAAA8PDw9PT0wxE7kAAAAAnRSTlMAxZ2d+wcAAAA9SURBVAjXbcqxDQAgCERRYmHh1MYJGMH6TynERAN6zSv+SVoFNRrMxHsE9eSx9QA/uki5DBiH6qgFsLyJWzC4LbEXwHUMAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/aboutus/content_fax.png
// module id = +qtM
// module chunks = 44